module.exports = __webpack_public_path__ + "img/SES_4069006540.21a5e155.jpg";